// extracted by mini-css-extract-plugin
export default {"container":"loader_container__JkypE","loader":"loader_loader__CQVg8","d5":"loader_d5__MgNDa"};